<template>
  <div class="notifications-modal">
    <div class="close" @click="close()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
      </svg>
    </div>

    <div class="notifications-inner">
      <svg v-if="isEnabled" width="56" height="50" viewBox="0 0 56 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M37.9719 0.0292972C41.1127 0.351563 43.5631 3.01758 43.5631 6.25V43.75C43.5631 46.9824 41.1127 49.6484 37.9719 49.9707L37.3398 50H18.6699L18.0379 49.9707C14.897 49.6484 12.4466 46.9824 12.4466 43.75L12.4466 6.25C12.4466 3.01758 14.897 0.351563 18.0379 0.0292972L18.6699 0L37.3398 0L37.9719 0.0292972ZM18.6699 4.6875C17.8142 4.6875 17.1141 5.39062 17.1141 6.25V43.75C17.1141 44.6094 17.8142 45.3125 18.6699 45.3125H37.3398C38.1955 45.3125 38.8956 44.6094 38.8956 43.75V6.25C38.8956 5.39062 38.1955 4.6875 37.3398 4.6875H18.6699ZM31.8944 35.9375C33.1877 35.9375 34.2282 36.9824 34.2282 38.2812C34.2282 39.5801 33.1877 40.625 31.8944 40.625H24.1153C22.822 40.625 21.7816 39.5801 21.7816 38.2812C21.7816 36.9824 22.822 35.9375 24.1153 35.9375H31.8944ZM4.74527 13.0273C5.65932 12.2754 7.01094 12.334 7.86664 13.1934C8.78069 14.1113 8.78069 15.5957 7.86664 16.5039L4.85223 19.5312L7.3221 22.0117L7.6041 22.3242C8.2167 23.0762 8.55704 24.0234 8.55704 25C8.55704 26.123 8.10974 27.1973 7.3221 27.9883L4.85223 30.4688L7.86664 33.4961L8.03195 33.6719C8.78069 34.5898 8.72235 35.9473 7.86664 36.8066C7.01094 37.666 5.65932 37.7148 4.74527 36.9727L4.57024 36.8164L1.23494 33.457C0.544539 32.7637 0.116687 31.8555 0.0194479 30.8887L0 30.4688L0.0194479 30.0488C0.116687 29.082 0.544539 28.1738 1.23494 27.4805L3.70481 25L1.23494 22.5195C0.544539 21.8262 0.116687 20.918 0.0194479 19.9512L0 19.5312L0.0194479 19.1113C0.116687 18.1445 0.544539 17.2363 1.23494 16.543L4.57024 13.1836L4.74527 13.0273ZM48.1334 13.1836C48.9891 12.3242 50.3407 12.2754 51.2547 13.0176L51.4298 13.1836L54.7651 16.5332C55.4555 17.2266 55.8833 18.1348 55.9806 19.1016L56 19.5215L55.9806 19.9414C55.8833 20.9082 55.4555 21.8164 54.7651 22.5098L52.2952 24.9902L54.7651 27.4707C55.4555 28.1641 55.8833 29.0723 55.9806 30.0391L56 30.459L55.9806 30.8789C55.8833 31.8457 55.4555 32.7539 54.7651 33.4473L51.4298 36.7969L51.2547 36.9629C50.3407 37.7148 48.9891 37.6562 48.1334 36.7969C47.2777 35.9375 47.229 34.5801 47.968 33.6621L48.1334 33.4863L51.1478 30.459L48.6779 27.9785C47.8903 27.1875 47.443 26.1133 47.443 24.9902C47.443 24.0137 47.7833 23.0664 48.3959 22.3145L48.6779 22.002L51.1478 19.5215L48.1334 16.4941C47.2193 15.5762 47.2193 14.0918 48.1334 13.1836Z" fill="#FFDE00"/>
      </svg>

      <svg v-else  width="56" height="50" viewBox="0 0 56 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.08825 25.6348C0.59183 25.2268 -0.300773 23.6904 0.0930224 22.2061C0.250541 21.5985 0.609332 21.069 1.10814 20.6958L2.097 19.9666C5.0811 17.7445 7.2251 14.5762 8.17896 10.974L8.68652 9.07302C10.4192 2.51949 17.175 -1.35186 23.7645 0.436254C27.5099 1.45183 30.389 4.07324 31.8679 7.34567C31.6317 7.39775 31.4041 7.45851 31.1679 7.51927C30.0215 7.83175 28.9276 8.25708 27.9037 8.77789C26.8886 6.72937 25.0247 5.0975 22.6531 4.45517C18.3126 3.27467 13.8846 5.80928 12.747 10.132L12.2482 12.033C11.1893 16.0432 8.94905 19.6281 5.82493 22.3363L19.0215 25.9125C19.109 26.5288 19.2402 27.1451 19.3978 27.7614L19.9053 29.6624C19.9841 29.9488 20.0453 30.2353 20.0978 30.5304C7.57514 27.1364 4.48603 26.2945 2.08825 25.6435V25.6348ZM20.1416 34.8531C20.0366 35.4781 19.8878 36.0944 19.6953 36.702C18.8464 37.2054 17.8576 37.5006 16.7987 37.5006C13.8759 37.5006 11.4693 35.2784 11.2156 32.44C15.311 33.5511 18.2864 34.3583 20.1416 34.8618V34.8531ZM53.9117 36.7454C32.533 42.5437 26.9936 44.0454 25.9085 44.3405L25.8648 44.3492C24.3858 44.7311 22.8807 43.8544 22.4869 42.3788C22.3293 41.7712 22.3731 41.1376 22.6269 40.556L23.1169 39.4189C24.6046 35.9815 24.8934 32.1536 23.9395 28.5513L23.432 26.6504C21.708 20.1055 25.646 13.335 32.2355 11.5469C38.825 9.75875 45.5808 13.6301 47.3135 20.1836L47.821 22.0846C48.7749 25.6869 50.9189 28.8551 53.903 31.0772L54.8919 31.8151C55.3907 32.1883 55.7495 32.7178 55.907 33.3254C56.3008 34.8097 55.4082 36.3461 53.9117 36.7541V36.7454ZM41.4678 44.4447L42.0016 44.2971C42.0016 44.3492 42.0016 44.3926 42.0016 44.4447C42.0016 46.7102 40.6365 48.6546 38.685 49.5226C38.1774 49.7483 37.6261 49.9045 37.0485 49.9653C36.8385 49.9913 36.6197 50 36.401 50C34.3007 50 32.463 48.8455 31.5092 47.1442L36.3572 45.8335L37.1623 45.6165L41.4766 44.4447H41.4678ZM50.1751 33.4469C47.051 30.7387 44.8107 27.1538 43.7518 23.1436L43.2443 21.2426C42.1066 16.9286 37.6786 14.394 33.3381 15.5658C28.9714 16.755 26.3461 21.2513 27.5012 25.6001L28 27.501C29.0589 31.4852 28.8926 35.6951 27.5537 39.5751L50.1751 33.4382V33.4469Z" fill="#FFDE00"/>
      </svg>

      <h2>{{ isEnabled ? `Notifications on. News, delivered.` : `Stay ahead of the headlines.` }}</h2>
      <p>{{ isEnabled ? `With notifications enabled, we'll bring you the top stories as they unfold. Fast, accurate, and relevant.` : `Enable notifications and we'll make sure you see the most important stories. All facts without the clickbait.` }}</p>
    </div>

    <div class="actions">
      <button @click="action()">
        <span>{{ isEnabled ? `Okay!` : `Enable notifications` }}</span>
        <svg v-if="!isEnabled" width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.2817 0.513181C22.0912 0.0878734 21.5845 -0.112478 21.1461 0.0702988L19.1336 0.913884C18.6952 1.09666 18.4939 1.59227 18.6808 2.02109C18.8677 2.44991 19.3744 2.64675 19.8128 2.46397L21.8253 1.62039C22.2638 1.43761 22.465 0.942004 22.2781 0.513181H22.2817ZM12 0.00351489C11.522 0.00351489 11.1375 0.379613 11.1375 0.8471V1.18805C8.21219 1.59578 5.9625 4.05975 5.9625 7.03339V7.54306C5.9625 8.86819 5.60312 10.1687 4.92031 11.3146L4.13328 12.6327C4.01109 12.8366 3.95 13.065 3.95 13.3005C3.95 14.0352 4.55734 14.6292 5.30844 14.6292H18.6916C19.4427 14.6292 20.05 14.0352 20.05 13.3005C20.05 13.065 19.9853 12.833 19.8667 12.6327L19.0797 11.3111C18.3969 10.1652 18.0375 8.86468 18.0375 7.53954V7.02988C18.0375 4.05624 15.7878 1.59227 12.8625 1.18453V0.843585C12.8625 0.376098 12.478 0 12 0V0.00351489ZM18.0519 12.9385H5.94453L6.40812 12.1617C7.24547 10.7592 7.6875 9.16345 7.6875 7.54306V7.03339C7.6875 4.70299 9.61734 2.81547 12 2.81547C14.3827 2.81547 16.3125 4.70299 16.3125 7.03339V7.54306C16.3125 9.16696 16.7545 10.7592 17.5883 12.1617L18.0519 12.9385ZM9.55984 16.3128C9.91563 17.297 10.8752 18 12 18C13.1248 18 14.0844 17.297 14.4402 16.3128H9.55984ZM0.5 6.471C0.5 6.93849 0.884531 7.31459 1.3625 7.31459H3.6625C4.14047 7.31459 4.525 6.93849 4.525 6.471C4.525 6.00352 4.14047 5.62742 3.6625 5.62742H1.3625C0.884531 5.62742 0.5 6.00352 0.5 6.471ZM20.3375 5.62742C19.8595 5.62742 19.475 6.00352 19.475 6.471C19.475 6.93849 19.8595 7.31459 20.3375 7.31459H22.6375C23.1155 7.31459 23.5 6.93849 23.5 6.471C23.5 6.00352 23.1155 5.62742 22.6375 5.62742H20.3375ZM2.17109 1.6239L4.18359 2.46749C4.62203 2.65026 5.12875 2.45343 5.31562 2.0246C5.5025 1.59578 5.30125 1.10018 4.86281 0.917399L2.85031 0.0738137C2.41547 -0.112478 1.90875 0.0878734 1.71828 0.513181C1.52781 0.938489 1.73266 1.43761 2.17109 1.62039V1.6239Z" fill="black"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    mounted () {
      this.EventBus.$on('notificationsEnabled', () => {
        this.close();
        this.EventBus.$emit('layer:new', {
          component: 'notifications',
        })
      });
    },

    computed: {
      isEnabled() {
        return this.$userEngine.hasNotifications;
      }
    },

    methods: {
      close() {
        this.$emit('close');
      },

      action() {
        if (this.isEnabled) {
          this.close()
        } else {
          this.EventBus.$emit("appCallback", {
            type: 'notificationsCallback',
            data: {}
          });

          this.EventBus.$emit('track:event', {
            label: 'StackFlow: Notifications',
            once: true,
          });
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .notifications-modal {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    padding: 1.5rem 1.5rem 2.5rem 1.5rem;
    color: white;
    background: black;
    border-top: 1px solid rgba($neutral-400, 0.25);
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-end;
      width: 44px;
      height: 44px;
      background: black;
      border: 1px solid rgba($neutral-400, 0.2);
      border-radius: 500px;
    }

    .notifications-inner {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
      padding-bottom: 2.5rem;

      svg {
        margin-bottom: 1rem;
      }

      h2 {
        font-family: 'Brawler';
        font-size: 2rem;
        font-weight: normal;
      }

      p {
        font-size: 1.1rem;
      }
    }

    .actions {
      display: flex;
      width: 100%;

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        margin-top: 0.5rem;
        height: 55px;
        border-radius: 10px;
        font-size: 1rem;
        padding-top: 0.8rem;
        width: 100%;
        color: black;
        background: $yellow-tone-3;
      }
    }
  }
</style>